import { render } from "./HomeView.vue?vue&type=template&id=3bc3bbd1&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=3bc3bbd1&lang=css"
import "./HomeView.vue?vue&type=style&index=1&id=3bc3bbd1&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp_form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc3bbd1"]])

export default __exports__